import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ai-locked__content" }
const _hoisted_2 = { class: "ai-locked__text" }
const _hoisted_3 = { class: "ai-locked__button__text" }

import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiLocked',
  props: {
  style: {
    type: Object as PropType<any>,
    required: false,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AiTooltip, {
    location: "bottom",
    "content-class": "ai-locked__tooltip",
    top: true
  }, {
    top: _withCtx(() => [
      _createElementVNode("div", {
        class: "ai-locked",
        style: _normalizeStyle(props.style)
      }, [
        _createVNode(_component_inline_svg, {
          src: require('@/assets/icons/locked.svg')
        }, null, 8, ["src"])
      ], 4)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.locked-text')), 1),
        _createVNode(_component_router_link, {
          to: { name: 'Subscriptions' },
          class: "ai-locked__button"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.locked-button')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})